export default {

    props: {
        userPermissions: {},
    },

    methods: {
        clicked(event) {
            this.$emit('click', event);
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/permission-buttons/PermissionButtonsHelperMixin.js